import gql from 'graphql-tag';

const mutation = gql`
  mutation GoalSettings(
    $weight: UserMeasurementWeightInputType!
    $dietMode: DietModeType!
    $goalWeight: UserMeasurementWeightInputType!
    $spontaneousActivityLevel: SpontaneousActivityLevelType!
    $activityLevel: DietActivityLevelType!
    $preferredMacronutrientRatio: MacronutrientRatioInputType!
  ) {
    me {
      goalSettings(
        weight: $weight
        dietMode: $dietMode
        goalWeight: $goalWeight
        spontaneousActivityLevel: $spontaneousActivityLevel
        activityLevel: $activityLevel
        preferredMacronutrientRatio: $preferredMacronutrientRatio
      ) {
        ... on BasicMutationSuccess {
          code
          __typename
        }
        ... on UnauthorizedException {
          code
          __typename
        }
        ... on ValidationException {
          code
          __typename
          messages
          details {
            fieldName
            messages
          }
        }
      }
    }
  }
`;

export default mutation;
